import { Directive, HostListener, Self, Optional } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appUppercase]',
  standalone: true
})
export class UppercaseDirective {
  constructor(@Optional() @Self() private ngControl: NgControl) {}

  @HostListener('input', ['$event'])
  onInput(event: Event) {
    const input = event.target as HTMLInputElement;
    if (!input) return;

    let start: number | null = null;
    let end: number | null = null;

    // 1. INTENTO SEGURO: Intentamos leer la posición del cursor de forma tradicional
    try {
      start = input.selectionStart;
      end = input.selectionEnd;
    } catch (error) {
      /** 
       * Si el input es type="email", el navegador fallará aquí.
       * Al atrapar el error, evitamos que la aplicación se rompa y el cursor salte.
       */
    }

    const uppercaseValue = input.value.toUpperCase();

    // 2. Actualizamos el control del formulario reactivo de Angular
    this.ngControl.control?.setValue(uppercaseValue, { emitEvent: false });

    // 3. Forzamos al elemento visual del DOM a pintar la mayúscula de inmediato
    input.value = uppercaseValue;

    // 4. RESTAURACIÓN ASÍNCRONA: Esperamos una milésima de segundo a que Angular termine de procesar
    setTimeout(() => {
      if (start !== null && end !== null) {
        try {
          input.setSelectionRange(start, end);
        } catch (error) {
          // Enfoque de respaldo si el navegador sigue bloqueando el input por tipo de dato
          input.focus();
        }
      }
    });
  }
}